import React from "react";
import axios from "axios";

import { ILoginRequestStateResult } from "../_core/models/ILoginRequestStateResult";
import { Settings } from "../_core/settings/Settings";
import { Utils } from "../_core/Utils";
import FallbackLandingPage from "./FallbackLandingPage";
import LoginPage from "./Login";

type LoginRequestViewState = "loading" | "login" | "fallback";

const hasReturnUrl = (): boolean => {
  const parsedParams = new URLSearchParams(window.location.search);
  const returnUrlParamValue =
    parsedParams.get("ReturnUrl") || parsedParams.get("returnUrl");

  return !!returnUrlParamValue;
};

const LoginContainer: React.FunctionComponent = () => {
  const [viewState, setViewState] =
    React.useState<LoginRequestViewState>("loading");
  const [fallbackUrl, setFallbackUrl] = React.useState<string>("");

  React.useEffect(() => {
    let isMounted = true;

    const validateLoginRequest = async () => {
      const returnUrl = hasReturnUrl()
        ? Utils.getReturnUrlFromLocation(window.location, false)
        : "";

      try {
        const result = await axios.get<ILoginRequestStateResult>(
          Settings.idsUrl + "/api/GetLoginRequestState",
          {
            params: { returnUrl },
            withCredentials: true,
          }
        );

        if (!isMounted) {
          return;
        }

        if (result.data.isValid) {
          setViewState("login");
          return;
        }

        if (result.data.redirectUrl) {
          window.location.replace(result.data.redirectUrl);
          return;
        }

        setFallbackUrl(result.data.fallbackUrl);
        setViewState("fallback");
      } catch {
        if (isMounted) {
          setViewState("fallback");
        }
      }
    };

    validateLoginRequest();

    return () => {
      isMounted = false;
    };
  }, []);

  if (viewState === "loading") {
    return null;
  }

  if (viewState === "login") {
    return <LoginPage />;
  }

  return <FallbackLandingPage fallbackUrl={fallbackUrl} />;
};

export default LoginContainer;
